import {Logger as LoggerProvider} from "@sap/cpaas-commlib-lib";
import {Configuration} from "./configuration";

export abstract class Logger {

	static fatal(message: string, details?: string) {
		return LoggerProvider.fatal(message, details, Configuration.component);
	}

	static error(message: string, details?: string) {
		return LoggerProvider.error(message, details, Configuration.component);
	}

	static warning(message: string, details?: string) {
		return LoggerProvider.warning(message, details, Configuration.component);
	}

	static info(message: string, details?: string) {
		return LoggerProvider.info(message, details, Configuration.component);
	}

	static debug(message: string, details?: string) {
		return LoggerProvider.debug(message, details, Configuration.component);
	}

	static trace(message: string, details?: string) {
		return LoggerProvider.trace(message, details, Configuration.component);
	}
}
